import * as React from 'react'
import { useCallback } from 'react'
import { styles } from './useStyles'

import IconButton from '@mui/material/IconButton'

import { useNavigate, useLocation } from 'react-router-dom'
import { styled } from '@mui/material/styles'

interface Props {
  colorful: boolean
  isNavLogo?: boolean
  isSettingsMode?: boolean
  isGuestUser?: boolean
  style?: Omit<React.CSSProperties, 'appearance'>
}

const StyledLogo = styled('img')({
  flex: '0 0 auto',
})

export const Logo: React.FC<Props> = (props) => {
  const { colorful, isNavLogo, style } = props
  const navigate = useNavigate()
  const location = useLocation()

  const src: string = colorful
    ? '/static-assets/logos/ww-marketing-logo.svg'
    : '/static-assets/logos/ww-marketing-logo-white.png'

  const handleClick = useCallback(() => {
    if (!isNavLogo) {
      return
    }

    if (location.pathname != '/scdashboard') {
      navigate('/scdashboard')
    }
  }, [navigate, location.pathname, isNavLogo])
  return (
    <IconButton
      sx={{ ...styles.logoBtn }}
      disabled={!isNavLogo}
      disableFocusRipple
      disableRipple
      onClick={handleClick}
      size="large"
      data-test-id="nav-logo"
    >
      <StyledLogo src={src} style={style} />
    </IconButton>
  )
}
